import { PAGE_TYPE, showsCsw } from '@/app/common/pageType.ts';

export type HeaderContext = {
  pageType: PAGE_TYPE;
  isApp: boolean;
  externalHeaderEnabled: boolean;
  appShowCsw: boolean;
};

export type HeaderVisibility = {
  showCsw: boolean;
  showExternalCSWDetail: boolean;
  showHeader: boolean;
  showAppCswOnly: boolean;
};

/**
 * Everything the header stack needs to know about a step, resolved together so the answers cannot
 * disagree. `showCsw` is the rule (see showsCsw); every other flag reads it.
 */
export const resolveHeaderVisibility = ({
  pageType,
  isApp,
  externalHeaderEnabled,
  appShowCsw,
}: HeaderContext): HeaderVisibility => {
  const showCsw = showsCsw(pageType);

  return {
    showCsw,
    // The external header (HP/HG) carries the CSW itself wherever there is one, so it reserves the
    // widget's height — the other brands get it for free inside the ContentHub header. The non-evo
    // detail steps have no list/index/map body class, so TopMargin needs that offset spelled out.
    // Both detail steps have a CSW, so showCsw adds nothing here. (MPH-864)
    showExternalCSWDetail: pageType === PAGE_TYPE.HOTEL_DETAIL || pageType === PAGE_TYPE.TRANSPORT_DETAIL,
    // In the app the header is the CSW (LM) or the external one (HP/HG) and nothing else, so a step
    // that withdraws the CSW leaves the LM app with no header to render. HP/HG stay on appShowCsw
    // alone — an LM CSW flag gating their external header is odd, but it is what the app does today
    // and untangling it is not this change's business.
    showHeader: !isApp || (appShowCsw && (externalHeaderEnabled || showCsw)),
    // MPH-395 workaround (see CSWAppContainer in styled.ts): standalone CSW in the app, LM only —
    // HP/HG (externalHeaderEnabled) keep their external-CSW handling.
    showAppCswOnly: isApp && appShowCsw && showCsw && !externalHeaderEnabled,
  };
};
